import styled from "styled-components";
import { MarketingModal, MarketingModalProps } from "../../organisms/Modal";
import { FC } from "react";
import { color } from "@styles";

interface ConfirmationModalProps extends MarketingModalProps {
  message: {
    header: string;
    body: string;
  };
}

export const ConfirmationModal: FC<ConfirmationModalProps> = ({
  message: { header, body },
  showModal,
  closeModal,
}) => {
  return (
    <MarketingModal
      closeOnClickOutside={true}
      showModal={showModal}
      closeModal={closeModal}
      exitButtonColor={color.B1100}
    >
      <ModalContainer>
        <ModalHeader>{header}</ModalHeader>
        <ModalSubtitle>{body}</ModalSubtitle>
      </ModalContainer>
    </MarketingModal>
  );
};

const ModalHeader = styled.p`
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: 0.0625rem;
  margin-bottom: 1rem;
`;

const ModalSubtitle = styled.p`
  font-size: 1rem;
  line-height: 1.5rem;
  letter-spacing: 0.0625rem;
`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem;
`;
